import React from 'react';
import ChartNode from './char-node';

type IOrgChartType = {
  dataSource: any;
};

const OrgChart = ({ dataSource }: IOrgChartType) => {
  return (
    <div className="org-chart-container ">
      <div className="org-chart">
        <ul>
          <ChartNode items={dataSource} />
        </ul>
      </div>
    </div>
  );
};

export default OrgChart;
